import React from 'react';
import { Col, Row } from 'react-bootstrap5';

import PropTypes from 'prop-types';
import Members from './Members';
import Assessments from './Assessments';
import AISessions from './AISessions';
import CoachingSessions from './CoachingSessions';

export default function Index({ members }) {
  return (
    <section>
      <h6 className="mb-3 fw-semibold">Member Engagement</h6>
      <Row>
        <Col key="members" md="3" className="mb-2 mb-md-0">
          <Members value={members?.length} />
        </Col>

        <Col md="3" className="mb-2 mb-md-0">
          <Assessments value={members?.reduce((sum, row) => sum + row.attributes.assessments_count, 0)} />
        </Col>

        <Col md="3" className="mb-2 mb-md-0">
          <AISessions value={members?.reduce((sum, row) => sum + row.attributes.ai_sessions_count, 0)} />
        </Col>

        <Col md="3" className="mb-2 mb-md-0">
          <CoachingSessions value={members?.reduce((sum, row) => sum + row.attributes.coaching_sessions_count, 0)} />
        </Col>
      </Row>

    </section>
  );
}

Index.propTypes = {
  members: PropTypes.arrayOf(PropTypes.object),
};

Index.defaultProps = {
  members: null,
};
